import {Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'app-simple-multi-select',
  templateUrl: './simple-multi-select.component.html',
  styleUrls: ['./simple-multi-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SimpleMultiSelectComponent),
      multi: true
    }
  ]
})
export class SimpleMultiSelectComponent implements ControlValueAccessor, OnInit {
  @Input() options: any[] = [];
  @Input() formatter = (o: any) => o?.label || o;
  @Input() selectedFormatter = (o: any) => o?.label || o;
  @Input() nullOption: boolean = false;
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() id?: string;
  @Input() small: boolean = false;
  @Input() optionVisible?: (option: any) => boolean;
  @Input() optionSelectable?: (option: any) => boolean;
  @Input() equalsFunction: (a: any, b: any) => boolean = (a, b) => a === b;

  @Output() selectionChange = new EventEmitter<any[]>();

  selectedValues: any[] = [];

  onChange = (_: any) => {};
  onTouched = () => {};

  _options: any[] = [];
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this._options = this.options || [];
  }

  isSelected(option: any): boolean {
    return this.selectedValues.some(v => this.equalsFunction(v, option));
  }

  toggleSelection(option: any): void {
    if (this.isSelected(option)) {
      this.selectedValues = this.selectedValues.filter(v => !this.equalsFunction(v, option));
    } else {
      this.selectedValues = [...this.selectedValues, option];
    }

    this.onChange(this.selectedValues);
    this.selectionChange.emit(this.selectedValues);
  }

  isDisabled(option: any): boolean {
    return this.optionSelectable && !this.optionSelectable(option);
  }

  writeValue(value: any[]): void {
    this.selectedValues = Array.isArray(value) ? value : [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  dropdownOpen = false;

  toggleDropdown() {
    if (!this.disabled) {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }

  clearSelection() {
    this.selectedValues = [];
    this.onChange([]);
    this.selectionChange.emit([]);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }
}
